import { Avatar, Box, Button, Card, CardContent, Chip, Divider, IconButton, Rating, Tooltip, Typography } from "@mui/material";
import { ACCENT, BADGE_STYLES, GRADIENT } from "./constants";
import { CheckCircleIcon } from "lucide-react";
import { formatPrice } from "./helpers";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import RemoveShoppingCartIcon from "@mui/icons-material/RemoveShoppingCart";
import ExtensionIcon from "@mui/icons-material/Extension";
function PluginCard({ item, bundle, purchased, toggleBundle, handleGet, onOpen }) {
  const inBundle = bundle.includes(item.id);
  const owned  = purchased.includes(item.id);
  const bStyle = item.badge ? BADGE_STYLES[item.badge] : null;
  return (
    <Card
      elevation={1}
      onClick={() => onOpen?.(item)}
      sx={{
        display: "flex",
        flexDirection: "column",
        borderRadius: 2,
        border: "1px solid",
        borderColor: "divider",
        transition: "box-shadow 0.15s",
        backgroundColor: "#fff",
        position: "relative",
        cursor: "pointer",
        "&:hover": { boxShadow: 4 },
      }}
    >
      <Box sx={{ position: "absolute", top: 0, right: 0, zIndex: 1, width: 22, height: 22, backgroundColor: ACCENT, display: "flex", alignItems: "center", justifyContent: "center", borderBottomLeftRadius: "50%", padding: 1 }}>
        <ExtensionIcon sx={{ fontSize: 13, color: "#fff" }} />
      </Box>
      <CardContent sx={{ flex: 1, pb: 1, display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5, mb: 1.5 }}>
          <Avatar
            src={item.imageUrl || ""}
            variant="rounded"
            sx={{ width: 48, height: 48, borderRadius: 1.5, flexShrink: 0 }}
          />
          <Box sx={{ minWidth: 0, display: "flex", flexDirection: "column", gap: 0.4, width: "100%", alignItems: "flex-start" }}>
            <Box sx={{ display: "flex", width: "100%", alignItems: "flex-start" }}>
              <Typography variant="subtitle2" fontWeight={700} sx={{ lineHeight: 1.3, color: "#1a1a1a" }}>
                {item.name}
              </Typography>
              {/* {item.badge && bStyle && (
                <Chip
                  label={item.badge}
                  size="small"
                  sx={{ ml: "auto", height: 18, fontSize: "0.68rem", fontWeight: 700, flexShrink: 0, backgroundColor: bStyle.bg, color: bStyle.color }}
                />
              )} */}
            </Box>
            <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 1.2 }}>
              {item.category}
            </Typography>
          </Box>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 1 }}>
          <Rating value={item.rating} precision={0.5} readOnly size="small" />
          <Typography variant="caption" color="text.secondary">({item.reviews})</Typography>
        </Box>

        <Tooltip title={item.description} placement="top" arrow>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden", lineHeight: 1.5, mb: 1, cursor: "default", textAlign: "left" }}
          >
            {item.description}
          </Typography>
        </Tooltip>

        <Chip label={item.type} size="small" sx={{ height: 20, fontSize: "0.65rem", width: "fit-content" }} />
      </CardContent>

      <Divider />

      <Box sx={{ px: 2, py: 1, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography fontWeight={700} fontSize="0.9rem" sx={{ color: item.price === 0 ? "#2e7d32" : "#1a1a1a" }}>
          {formatPrice(item.price)}
        </Typography>
        <Box sx={{ display: "flex", gap: 0.75, alignItems: "center" }}>
          {owned ? (
            <Chip
              icon={<CheckCircleIcon sx={{ fontSize: "0.95rem !important", color: "#2e7d32 !important" }} />}
              label="Installed"
              size="small"
              color="success"
              variant="outlined"
              sx={{ height: 24, fontSize: "0.7rem" }}
            />
          ) : (
            <>
              <Tooltip title={inBundle ? "Remove from Cart" : "Add to Cart"} arrow>
                <IconButton
                  size="small"
                  onClick={(e) => { e.stopPropagation(); toggleBundle(item.id); }}
                  sx={{ border: "1px solid", borderColor: inBundle ? ACCENT : "#ccc", color: inBundle ? ACCENT : "#aaa", borderRadius: 1, p: 0.5 }}
                >
                  {inBundle ? <RemoveShoppingCartIcon sx={{ fontSize: 15 }} /> : <AddShoppingCartIcon sx={{ fontSize: 15 }} />}
                </IconButton>
              </Tooltip>
              <Button
                size="small"
                disableElevation
                onClick={(e) => { e.stopPropagation(); handleGet(item); }}
                sx={{
                  textTransform: "none",
                  fontWeight: 600,
                  fontSize: "0.78rem",
                  background: item.price === 0 ? "linear-gradient(90deg, #388e3c, #2e7d32)" : GRADIENT,
                  color: "#fff",
                  boxShadow: "none",
                  "&:hover": { opacity: 0.92, boxShadow: "none" },
                }}
              >
                {item.price === 0 ? "Get Free" : "Buy"}
              </Button>
            </>
          )}
        </Box>
      </Box>
    </Card>
  );
}

export default PluginCard;